import React from 'react';

type Props = {
  section?: Boolean;
};

function Divider(props: Props) {
  return <hr className={props.section ? 'my-8' : 'my-2'} />;
}

export default Divider;
